import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'

export const getDirectionBreakByClass = (value: string): FlexDirectionBreak => {
  switch (value) {
    case 'col-1':
      return FlexDirectionBreak.p112
    case 'col-2':
      return FlexDirectionBreak.p212
    case 'col-3':
      return FlexDirectionBreak.p312
    case 'col-4':
      return FlexDirectionBreak.p412
    case 'col-5':
      return FlexDirectionBreak.p512
    case 'col-6':
      return FlexDirectionBreak.p612
    case 'col-7':
      return FlexDirectionBreak.p712
    case 'col-8':
      return FlexDirectionBreak.p812
    case 'col-9':
      return FlexDirectionBreak.p912
    case 'col-10':
      return FlexDirectionBreak.p1012
    case 'col-11':
      return FlexDirectionBreak.p1112
    case 'col-12':
      return FlexDirectionBreak.p1212
  }
  return '' as FlexDirectionBreak
}
